import { render, staticRenderFns } from "./paymentNormal.vue?vue&type=template&id=6a22520a&scoped=true&"
import script from "./paymentNormal.vue?vue&type=script&lang=js&"
export * from "./paymentNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22520a",
  null
  
)

export default component.exports